import React from "react";
import ClientCreate from "@/res/components/ClientCreate";
import useRedirect from "@/components/redirect";

export { getStaticPaths } from "@/res/components/boilerplate/paths/default";
export { getStaticProps } from "@/res/components/boilerplate/props/details";

const Index = (props) => {
    useRedirect(`${props?.details?.code}no`, true);
    return (
        <ClientCreate {...props}/>
    );
};

export default Index;
